
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/leftBar/leftBarMenu/leftBarMenu.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_m5ees_7","list":"_list_m5ees_18","item":"_item_m5ees_25","primary":"_primary_m5ees_32"};